/*! Bookeaz — restrict hyperlocal results to the nearest seller only (v10: nearest seller, auto seller lookup, cart guard, hide unavailable categories with verified vendor check) */
(function () {
  'use strict';
  var DETAILS_KEY = 'wk_seller_details_for_hyp';
  var IDS_KEY = 'wk_seller_ids';
  var IDS_STR_KEY = 'wk_seller_ids_str_hyp';
  var STORES_KEY = 'wk_seller_stores';
  var ENC_KEY = 'wk_encrypted_seller_ids';
  var nativeSetItem = Storage.prototype.setItem;

  function dist(s) {
    if (!s) return NaN;
    var v = s.customer_dist !== undefined ? s.customer_dist : s.customer_distance;
    return parseFloat(v);
  }
  function radius(s) {
    var r = parseFloat(s && s.max_delv_dist);
    return isNaN(r) ? 0 : r;
  }

  Storage.prototype.setItem = function (key, value) {
    if (this === window.localStorage && key === DETAILS_KEY) {
      try {
        var details = JSON.parse(value);
        var keys = Object.keys(details || {});
        if (keys.length > 1) {
          var nearestKey = null, nearestDist = Infinity, nearestRadius = -1;
          keys.forEach(function (k) {
            var d = dist(details[k]);
            if (isNaN(d)) return;
            var r = radius(details[k]);
            if (d < nearestDist || (d === nearestDist && r > nearestRadius)) {
              nearestDist = d; nearestRadius = r; nearestKey = k;
            }
          });
          if (nearestKey === null) nearestKey = keys[0];
          var nearest = details[nearestKey];
          var filtered = {};
          filtered[nearestKey] = nearest;
          window.__bookeazNearestSeller = nearest;
          value = JSON.stringify(filtered);
        } else {
          window.__bookeazNearestSeller = null;
        }
      } catch (e) { window.__bookeazNearestSeller = null; }
    } else if (this === window.localStorage && window.__bookeazNearestSeller) {
      if (key === IDS_STR_KEY) value = String(window.__bookeazNearestSeller.id_seller);
      else if (key === IDS_KEY) value = JSON.stringify([window.__bookeazNearestSeller.id_seller]);
      else if (key === STORES_KEY) value = JSON.stringify([window.__bookeazNearestSeller.sp_store_name]);
      else if (key === ENC_KEY) value = '';
    }
    return nativeSetItem.call(this, key, value);
  };
})();

/* ---- Auto seller lookup: when a location is set but Webkul has not filled in the seller keys, ask it once and refresh ---- */
(function () {
  'use strict';
  var attempts = {};
  function sig() {
    try { return (localStorage.getItem('wk_customer_location') || '') + '|' + (localStorage.getItem('wk_hyperlocal_zipcode') || ''); } catch (e) { return ''; }
  }
  function have() {
    try { var s = JSON.parse(localStorage.getItem('wk_seller_stores') || '[]'); return !!(s && s.length > 0); } catch (e) { return false; }
  }
  function tick() {
    try {
      if (!localStorage.getItem('wk_customer_location')) return;
      if (have()) return;
      var k = sig();
      if ((attempts[k] || 0) >= 4) return;
      if (typeof hypObj === 'undefined' || !hypObj || typeof hypObj.getSellerDetailsByCustLocation !== 'function') return;
      attempts[k] = (attempts[k] || 0) + 1;
      try { hypObj.getSellerDetailsByCustLocation(); } catch (e) {}
      setTimeout(function () {
        try {
          if (have()) {
            var rk = 'bkzSellerSync:' + k;
            if (!sessionStorage.getItem(rk)) { sessionStorage.setItem(rk, '1'); window.location.reload(); }
          }
        } catch (e) {}
      }, 3500);
    } catch (e) {}
  }
  document.addEventListener('DOMContentLoaded', function () { setTimeout(tick, 500); setInterval(tick, 1500); });
})();

/* ---- Bookeaz cart seller guard (v2): keep cart limited to the nearest seller + publish it as cart attribute ---- */
(function () {
  'use strict';
  var SKIP_TYPES = ['fast delivery', 'tips-hidden'];
  var running = false;
  function norm(s) { return String(s || '').toLowerCase().replace(/\.com$/, '').replace(/[^a-z0-9]/g, ''); }
  function nearestName() {
    try {
      var st = JSON.parse(localStorage.getItem('wk_seller_stores') || '[]');
      if (st && st.length === 1) return st[0];
    } catch (e) {}
    return null;
  }
  function notice(msg) {
    try {
      var el = document.createElement('div');
      el.setAttribute('role', 'alert');
      el.style.cssText = 'position:fixed;left:50%;bottom:70px;transform:translateX(-50%);max-width:92vw;background:#1f2937;color:#fff;padding:12px 16px;border-radius:8px;z-index:99999;font-size:14px;box-shadow:0 4px 12px rgba(0,0,0,.3)';
      el.textContent = msg;
      document.body.appendChild(el);
      setTimeout(function () { el.remove(); }, 9000);
    } catch (e) {}
  }
  function check() {
    if (running) return;
    var nearest = nearestName();
    if (!nearest) return;
    running = true;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var attrSync = Promise.resolve();
      if (!cart.attributes || cart.attributes.nearest_seller !== nearest) {
        attrSync = fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { nearest_seller: nearest } }) });
      }
      var bad = (cart.items || []).filter(function (it) {
        if (it.gift_card) return false;
        if (SKIP_TYPES.indexOf(String(it.product_type || '').toLowerCase()) !== -1) return false;
        return norm(it.vendor) !== norm(nearest);
      });
      if (!bad.length) { return attrSync; }
      var chain = attrSync;
      bad.forEach(function (it) {
        chain = chain.then(function () {
          return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: it.key, quantity: 0 }) });
        });
      });
      return chain.then(function () {
        notice('Removed ' + bad.map(function (b) { return b.product_title; }).join(', ') + ' — not sold by the seller nearest to your location.');
        setTimeout(function () { window.location.reload(); }, 2500);
      });
    }).catch(function () {}).then(function () { running = false; });
  }
  document.addEventListener('DOMContentLoaded', function () { setTimeout(check, 1500); });
  window.addEventListener('focus', function () { setTimeout(check, 500); });
  var nf = window.fetch;
  window.fetch = function (url) {
    var p = nf.apply(this, arguments);
    try { if (/\/cart\/(add|change)/.test(String(url && url.url || url))) p.then(function () { setTimeout(check, 900); }); } catch (e) {}
    return p;
  };
})();

/* ---- Bookeaz category availability: hide category tiles the nearest seller has no products in ---- */
(function () {
  'use strict';
  var TTL = 10 * 60 * 1000, running = false, lastKey = null, tried = {}, triedFor = '';
  var FORM_URL = 'https://tally.so/r/yPY1Q0';
  function norm(s) { return String(s || '').toLowerCase().replace(/\.com\b/g, '').replace(/[^a-z0-9]/g, ''); }
  function nearestName() {
    try {
      var st = JSON.parse(localStorage.getItem('wk_seller_stores') || '[]');
      if (st && st.length === 1 && st[0]) return String(st[0]);
    } catch (e) {}
    return null;
  }
  function sig() {
    try { return (localStorage.getItem('wk_customer_location') || '') + '|' + (localStorage.getItem('wk_seller_stores') || ''); } catch (e) { return ''; }
  }
  function cacheGet(store) {
    try {
      var c = JSON.parse(sessionStorage.getItem('bkzCatAvail3:' + norm(store)) || 'null');
      if (c && Date.now() - c.t < TTL) return c;
    } catch (e) {}
    return null;
  }
  function cacheSet(store, c) { try { sessionStorage.setItem('bkzCatAvail3:' + norm(store), JSON.stringify(c)); } catch (e) {} }
  function tiles() { return Array.prototype.slice.call(document.querySelectorAll('a.bkz-tile[href*="/collections/"]')); }
  function handleOf(a) { var m = (a.getAttribute('href') || '').match(/\/collections\/([^/?#]+)/); return m ? m[1] : ''; }
  function style() {
    if (document.getElementById('bkz-na-style')) return;
    var s = document.createElement('style');
    s.id = 'bkz-na-style';
    s.textContent = '.bkz-tile--na{display:none!important}html.bkz-cat-pending a.bkz-tile{visibility:hidden}.bkz-na-note{grid-column:1/-1;text-align:center;font-size:14px;margin:14px 0;color:#555}.bkz-na-note a{color:inherit;font-weight:600;text-decoration:underline}';
    (document.head || document.documentElement).appendChild(s);
  }
  function pending(on) {
    var h = document.documentElement;
    if (on) { style(); h.classList.add('bkz-cat-pending'); } else { h.classList.remove('bkz-cat-pending'); }
  }
  (function early() {
    var s = nearestName();
    if (s && !cacheGet(s)) { pending(true); setTimeout(function () { pending(false); }, 8000); }
  })();
  function mark(avail) {
    style();
    var list = tiles(), hidden = 0;
    list.forEach(function (a) {
      var na = !!(avail && avail[handleOf(a)] === false);
      a.classList.toggle('bkz-tile--na', na);
      if (na) hidden++;
    });
    var old = document.getElementById('bkz-na-note');
    if (old) old.remove();
    if (hidden && list.length) {
      var vis = list.filter(function (a) { return !a.classList.contains('bkz-tile--na'); });
      var anchor = vis.length ? vis[vis.length - 1] : list[list.length - 1];
      var note = document.createElement('div');
      note.id = 'bkz-na-note';
      note.className = 'bkz-na-note';
      note.innerHTML = 'More categories are coming to your area. <a href="' + FORM_URL + '" target="_blank" rel="noopener noreferrer">Tell us what you’d like</a>';
      anchor.insertAdjacentElement('afterend', note);
    }
    pending(false);
  }
  function vendorLookup(q, store) {
    return fetch('/collections/vendors?q=' + encodeURIComponent(q), { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) {
      var d = new DOMParser().parseFromString(t, 'text/html');
      var vals = Array.prototype.map.call(d.querySelectorAll('input[name="filter.p.vendor"]'), function (i) { return i.value; });
      for (var i = 0; i < vals.length; i++) if (norm(vals[i]) === norm(store)) return vals[i];
      return null;
    }).catch(function () { return null; });
  }
  function vendorValue(store) {
    return vendorLookup(store, store).then(function (v) { return v || vendorLookup(store + '.com', store); });
  }
  /* Reads the product count of a collection page: n = number shown, of = true when the page says "N of M" (a filter really narrowed it). */
  function pageCount(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('x'); return r.text(); })
      .then(function (t) {
        var d = new DOMParser().parseFromString(t, 'text/html');
        var c = d.querySelector('#ProductCountDesktop');
        var txt = c ? (c.textContent || '').replace(/,/g, '') : '';
        var m1 = txt.match(/(\d+)\s+of\s+\d+/), m2 = txt.match(/(\d+)\s+product/);
        var n = m1 ? parseInt(m1[1], 10) : (m2 ? parseInt(m2[1], 10) : d.querySelectorAll('.card-wrapper, .product-card-wrapper').length);
        return { n: n, of: !!m1 };
      });
  }
  /* True only if the seller really has products in this category. Vendor-rule collections ignore the vendor filter,
     so when the count did not narrow, probe with a vendor that cannot exist and, if the filter is ignored, read the real vendors. */
  function hasProducts(handle, vendor) {
    var base = '/collections/' + handle + '?filter.p.vendor=';
    return pageCount(base + encodeURIComponent(vendor)).then(function (r) {
      if (r.n === 0) return false;
      if (r.of) return true;
      return pageCount(base + encodeURIComponent('zz-no-such-vendor-zz')).then(function (p) {
        if (p.n === 0) return true;
        return fetch('/collections/' + handle + '/products.json?limit=30', { credentials: 'same-origin' })
          .then(function (x) { return x.json(); })
          .then(function (j) {
            var ps = (j && j.products) || [];
            return ps.some(function (it) { return norm(it.vendor) === norm(vendor); });
          });
      });
    });
  }
  function run() {
    if (running) return;
    var list = tiles();
    var store = nearestName();
    if (!list.length) { pending(false); return; }
    if (!store) { mark(null); return; }
    if (triedFor !== store) { tried = {}; triedFor = store; }
    var c = cacheGet(store) || { t: Date.now(), a: {}, v: null };
    var todo = list.map(handleOf).filter(function (h) { return h && !Object.prototype.hasOwnProperty.call(c.a, h) && !tried[h]; });
    todo = todo.filter(function (h, i) { return todo.indexOf(h) === i; });
    if (!todo.length) { mark(c.a); return; }
    running = true;
    if (!Object.keys(c.a).length) pending(true);
    (c.v ? Promise.resolve(c.v) : vendorValue(store)).then(function (vendor) {
      if (!vendor) { todo.forEach(function (h) { tried[h] = 1; }); mark(c.a); return; }
      c.v = vendor;
      var i = 0;
      function worker() {
        if (i >= todo.length) return Promise.resolve();
        var h = todo[i++];
        tried[h] = 1;
        return hasProducts(h, vendor).then(function (ok) { c.a[h] = ok; }, function () {}).then(worker);
      }
      return Promise.all([worker(), worker(), worker(), worker(), worker(), worker()]).then(function () {
        cacheSet(store, c);
        mark(c.a);
      });
    }).catch(function () { mark(c.a); }).then(function () { running = false; lastKey = null; });
  }
  function tick() {
    if (running) return;
    var k = sig() + '|' + tiles().length;
    if (k !== lastKey) { lastKey = k; run(); }
  }
  document.addEventListener('DOMContentLoaded', function () { setTimeout(tick, 600); setInterval(tick, 1000); });
})();
